import { SVGProps, Ref, forwardRef } from 'react';

export const ArrowDiagonalLeftDownOutlinedSize24Glyph = forwardRef(
    (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
        <svg
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <g>
                <path d="M5.8 7H4v13h13v-1.8H7.073L20 5.273 18.727 4 5.8 16.927z" fill="currentColor" />
            </g>
        </svg>
    )
);
ArrowDiagonalLeftDownOutlinedSize24Glyph.displayName = 'ArrowDiagonalLeftDownOutlinedSize24Glyph';
